const INIT_DATA_KEY = "kmk:telegram-init-data"

/** Подпись Telegram из адреса Mini App: `#tgWebAppData=…`. Роутер потом переписывает адрес. */
export function parseTelegramInitData(hash: string): string | null {
	const params = new URLSearchParams(hash.replace(/^#/, ""))
	const initData = params.get("tgWebAppData")
	return initData && new URLSearchParams(initData).has("hash") ? initData : null
}

/**
 * Запоминает подпись до первого перехода по страницам, чтобы вход по Telegram
 * пережил и навигацию роутера, и перезагрузку вкладки внутри Telegram.
 */
export function captureTelegramInitData(): void {
	const initData = parseTelegramInitData(window.location.hash)
	if (!initData) return
	sessionStorage.setItem(INIT_DATA_KEY, initData)
	window.history.replaceState(null, "", window.location.pathname + window.location.search)
}

export function storedTelegramInitData(): string | null {
	return sessionStorage.getItem(INIT_DATA_KEY)
}

export function forgetTelegramInitData(): void {
	sessionStorage.removeItem(INIT_DATA_KEY)
}

type TelegramWindow = Window & {
	TelegramWebviewProxy?: { postEvent: (type: string, data: string) => void }
}

/** Просит Telegram раскрыть окно на весь экран: бэкофису тесно в половине. */
export function expandTelegramMiniApp(): void {
	for (const type of ["web_app_ready", "web_app_expand"]) {
		const proxy = (window as TelegramWindow).TelegramWebviewProxy
		if (proxy) proxy.postEvent(type, "")
		else if (window.parent !== window)
			window.parent.postMessage(JSON.stringify({ eventType: type, eventData: "" }), "*")
	}
}
